{
  "common.language.label": "Language",
  "common.language.automatic": "Automatic ({language})",
  "common.language.pseudo": "Pseudo-English (development)",
  "common.brand.logoAlt": "Suikamon",
  "common.action.cancel": "Cancel",
  "common.action.close": "Close",
  "common.action.submit": "Submit",
  "common.action.next": "Next",
  "common.status.comingSoon": "Coming Soon",
  "common.status.unknown": "Unknown",
  "common.action.confirm": "Confirm",
  "common.status.saving": "Saving…",
  "common.action.back": "← Back",
  "common.status.loading": "Loading…",
  "common.currency.suika": "{count, plural, one {Suika} other {Suika}}",
  "common.currency.tracks": "{count, plural, one {Soul Dust} other {Soul Dust}}",
  "common.currency.gainSuika": "+{amount} {amount, plural, one {Suika} other {Suika}}",
  "common.currency.gainTracks": "+{amount} {amount, plural, one {Soul Dust} other {Soul Dust}}"
}
